import React, { useState, useEffect } from 'react';
import { TextField, Button, CircularProgress, Stack, Typography, MenuItem, FormControl, InputLabel, Select, Card, CardContent, CardHeader } from '@mui/material';
import { useContent } from '../../../../context/ContentContext';

const RecruitAgentDisplay = () => {
    const { categories, loading, userData, addresses } = useContent();
    const [nameAffiliate] = useState(userData?.name || '');
    const [referralIdAffiliate] = useState(userData?.referral_id || '');
    const [mounted, setMounted] = useState(false);

    const WhatsAppBooking = ({ branches }) => {
        const [name, setName] = useState('');
        const [phone, setPhone] = useState('');
        const [message, setMessage] = useState('');

        const handleSubmit = () => {
            // Check if essential fields are filled in
            if (!name || !phone) {
                alert('Please fill in all fields and select a valid phone number.');
                return; // Prevent submission if validation fails
            }

            // Format the phone number
            let formattedPhone = phone.trim();
            if (formattedPhone.startsWith('0')) {
                formattedPhone = `62${formattedPhone.slice(1)}`; // Replace leading '0' with '62'
            } else if (formattedPhone.startsWith('+62')) {
                formattedPhone = formattedPhone.slice(1); // Remove the '+' sign
            } else if (!formattedPhone.startsWith('62')) {
                alert('Invalid phone number format. Please start with 0 or +62.');
                return;
            }

            // Get the registration link from the environment variable
            const registrationLink = `${process.env.REACT_APP_SERVER_URL}/register?ref=${referralIdAffiliate}`;

            const whatsappMessage = `
            Halo, ${name}, ini saya ${nameAffiliate}.\n
            Pesan:
            ${message}\n
            Pakai link ini untuk register, ya: ${registrationLink}
            `;

            const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodeURIComponent(whatsappMessage)}`;
            window.open(whatsappUrl, '_blank');
        };

        useEffect(() => {
            if (!mounted) {
                setMounted(true);
            }
        }, [mounted]);

        if (loading || !mounted) {
            return <CircularProgress />;
        }

        if (!categories || categories.length === 0) {
            return (
                <Stack sx={{ width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center' }} direction="column" spacing={2}>
                    <Typography variant="h6">Tidak ada Form Order</Typography>
                    <img
                        src="/images/NoResultFound.webp"
                        alt="No categories found"
                        style={{ width: '300px', height: 'auto' }}
                    />
                </Stack>
            );
        }

        return (
            <Stack
                spacing={3}
                sx={{
                    p: 0,
                    width: {
                        xs: '100vw',  // On extra small devices (mobile)
                        sm: '100vw',  // On small devices (tablet)
                        md: '100vw',  // On medium devices
                        lg: '80vw',  // On large devices
                    },
                    mx: 'auto', // Center the stack horizontally
                }}
            >
                <Card
                    sx={{
                        maxWidth: '90vw',  // Restrict maximum width to 90% of the viewport width
                        mx: 'auto',       // Center the card horizontally
                        boxShadow: 3,
                        borderRadius: 2
                    }}
                >
                    <CardHeader title="Rekrut Downline" />
                    <CardContent>
                        <Stack spacing={1}>
                            <TextField
                                label="Nama"
                                fullWidth
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <TextField
                                label="Telepon"
                                fullWidth
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                            <TextField
                                label="Referral ID"
                                fullWidth
                                value={referralIdAffiliate} // Use referralIdAffiliate directly from userData
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                            <TextField
                                label="Pesan"
                                fullWidth
                                multiline
                                rows={Infinity}
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                sx={{
                                    height: '100px', // Set the total height of the input field
                                    '& .MuiInputBase-root': {
                                        height: '100px', // Target the root input field
                                    },
                                }} />
                        </Stack>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            fullWidth
                            sx={{ mt: 2 }}
                        >
                            Send WhatsApp
                        </Button>
                    </CardContent>
                </Card>
            </Stack>
        );
    };

    return <WhatsAppBooking branches={addresses} />;
};

export default RecruitAgentDisplay;
